import {Calendar} from 'vanilla-calendar-pro';
import {handleReloadedContent, reload, showToast} from "../global/utilities";

class Planning {
    resamaniaPlanningAjax;

    constructor() {
        const init = () => {
            this.init();
            this.bindEvents();
        }

        document.addEventListener('DOMContentLoaded', init);
        window.addEventListener('contentReady', init);
    }

    async mobileDayNumberHandler(mobileDayNumber, container, direction) {
        // Calculate new position
        const newDayNumber = direction === 'next' ? mobileDayNumber + 1 : mobileDayNumber - 1;

        // Calculate translation percentage
        const translationPercentage = direction === 'next'
            ? (newDayNumber) * -(100)
            : (newDayNumber) * -(100);

        // Apply transform
        container.querySelectorAll('.planning-day').forEach(day => {
            day.style.transform = `translateX(${translationPercentage}%)`;
        });

        // Handle week changes
        if (newDayNumber < 0) {
            await this.changeWeek('previous');
            this.init();
            return 0;
        } else if (newDayNumber > 5) {
            await this.changeWeek('next');
            this.init();
            return 0;
        }

        return newDayNumber;
    }

    init() {
        this.container = document.querySelector('.planning-container');

        if (!this.container) {
            return;
        }

        this.planningContainer = this.container.querySelector('.planning-container-wrapper')
        this.initWeekPicker();
    }

    bindEvents() {
        let mobileDayNumber = 0;

        if (!this.container) {
            return;
        }

        document.querySelector('.week-picker-container').addEventListener('click', (e) => {
            const target = e.target;

            if (target.matches('.week-picker-container')) {
                this.toggleWeekPicker();
            }
        });

        this.container.addEventListener('click', async (e) => {
            const target = e.target;

            switch (true) {
                case target.matches('[data-action="previous-week"]'):
                    if (window.matchMedia('(min-width: 769px)').matches) {
                        await this.changeWeek('previous');
                    } else {
                        mobileDayNumber = await this.mobileDayNumberHandler(mobileDayNumber, this.planningContainer, 'back');
                    }
                    break;

                case target.matches('[data-action="next-week"]'):
                    if (window.matchMedia('(min-width: 769px)').matches) {
                        await this.changeWeek('next');
                    } else {
                        mobileDayNumber = await this.mobileDayNumberHandler(mobileDayNumber, this.planningContainer, 'next');
                    }
                    break;

                case target.matches('.week'):
                    e.preventDefault();
                    mobileDayNumber = 0;
                    this.toggleWeekPicker();
                    break;

                case target.matches('.signup-button'):
                    const eventId = target.dataset.eventId;
                    const action = target.dataset.action === 'unsubscribe' ? 'cancelSignupToEvent' : (target.dataset.action === 'unqueued' ? 'unqueuedEvent' : 'signupToEvent');
                    this[action](eventId, target);
                    break;

                case target.closest('.event') !== null:
                    const id = target.closest('.event').dataset.eventId;
                    this.openReservationPopup(id);
                    break;

                case target.matches('.back-to-planning'):
                case target.matches('.planning-overlay'):
                    this.closeReservationPopup();
                    break;

                case target.matches('.activity-selector'):
                    const activityId = target.getAttribute('data-activity-id');
                    this.selectActivityType(activityId);
                    break;

                case target.matches('.coach-selector-action'):
                    document.querySelector('.coach-selector-window').classList.toggle('active');
                    break;

                case target.matches('.coach-selector-item'):
                    const coachIds = target.getAttribute('data-coach-id');
                    this.selectCoach(coachIds);
                    document.querySelector('.coach-selector-window').classList.toggle('active');
                    break;

                case target.matches('.coach-selector-close'):
                    document.querySelector('.coach-selector-window').classList.toggle('active');
                    break;
            }
        });
    }

    async openReservationPopup(eventId) {
        const {overlay, popup} = this.getPopupElements();
        overlay.style.display = 'block';

        const response = await this.fetchEventDetails(eventId);
        if (!response.success) {
            console.error('Error fetching event details:', response.data);
            return;
        }

        // console.log(response)

        const {
            event: eventDetails,
            coach: coachDetails,
            activity: activityDetails,
            is_user_attending: isUserAttending,
            is_user_queued: isUserQueued,
            description: description,
            instructions: instructions,
        } = response.data;
        this.updatePopupContent(popup, eventDetails, coachDetails, activityDetails, description, instructions);
        this.updateSignupButton(popup, eventDetails, isUserAttending, isUserQueued);

        popup.style.display = 'block';
    }

    getPopupElements() {
        const overlay = this.container.querySelector('.planning-overlay');
        const popup = this.container.querySelector('.planning-popup');
        return {overlay, popup};
    }

    async fetchEventDetails(eventId) {
        return await jQuery.ajax({
            url: ajax_object.ajax_url,
            method: 'POST',
            data: {action: 'get_event', event_id: eventId}
        });
    }

    updatePopupContent(popup, eventDetails, coachDetails, activityDetails, description, instruction) {
        const eventStartDate = new Date(eventDetails.startedAt);
        const spotsLeft = eventDetails.attendingLimit - eventDetails.bookedAttendees.length;

        popup.querySelector('.event-schedule').textContent = eventStartDate.toLocaleDateString('fr-FR', {
            weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'
        });
        popup.querySelector('.event-description').innerHTML = description !== "" ? description : `                    
            <p>
                Entraînement éducatif <em>encadré</em>&nbsp;: exercices communs à l'ensemble des participants,
                intensité adaptée en fonction de mon profil de santé.
            </p>
        `;
        popup.querySelector('.warning-signout').textContent = instruction !== "" ? instruction : `La désinscription n'est plus possible moins de 60 min avant le début du cours, et le crédit de séance ne sera pas restitué`;
        popup.querySelector('.event-coach').textContent = coachDetails ? coachDetails.givenName : 'Coach non renseigné';
        popup.querySelector('.event-name').textContent = activityDetails.name.replace(' (P13)', '');
        popup.querySelector('.event-spots-left').textContent = this.formatSpotsLeft(spotsLeft);
        popup.querySelector('.signup-button').dataset.eventId = eventDetails['@id'];
    }

    updateSignupButton(popup, eventDetails, isUserAttending, isUserQueued) {
        // console.log(eventDetails)
        const signupButton = popup.querySelector('.signup-button');
        const spotsLeft = eventDetails.attendingLimit - eventDetails.bookedAttendees.length;
        const buttonState = this.getButtonState(spotsLeft, isUserAttending, eventDetails.queueRemaining === 0, isUserQueued);

        const eventDate = new Date(eventDetails.startedAt);
        const now = new Date();

        if (eventDate < now) {
            signupButton.disabled = true;
            signupButton.textContent = 'Cours passé';
        } else {
            signupButton.disabled = buttonState.disabled;
            signupButton.textContent = buttonState.text;
            signupButton.dataset.action = buttonState.action || 'signup';
        }
    }

    getButtonState(spotsLeft, isUserAttending, isQueueFull, isUserQueued) {
        const states = {
            noSpots: {disabled: true, text: 'Complet'},
            attending: {disabled: false, text: 'Se désinscrire', action: 'unsubscribe'},
            queueAvailable: {disabled: false, text: 'Rejoindre la liste d\'attente'},
            inQueue: {disabled: false, text: 'M\'enlever de la liste d\'attente', action: 'unqueued'},
            queueFull: {disabled: true, text: 'Liste d\'attente complète'},
            default: {disabled: false, text: 'Réserver'}
        };

        if (isUserAttending) return states.attending;
        if (isUserQueued) return states.inQueue;
        if (isQueueFull) return states.queueFull;
        if (spotsLeft === 0 && !isQueueFull) return states.queueAvailable;
        if (spotsLeft === 0) return states.noSpots;
        return states.default;
    }

    formatSpotsLeft(spotsLeft) {
        return spotsLeft > 0
            ? `${spotsLeft} place${spotsLeft > 1 ? 's' : ''} restante${spotsLeft > 1 ? 's' : ''}`
            : 'Complet';
    }

    updateCard(eventId, signup = true) {
        const card = document.querySelector(`[data-event-id="${eventId}"]`);
        const attendees = card.querySelector('.attendees');
        const attendeesTxt = attendees.innerText.split('/');
        const attendeesCount = parseInt(attendeesTxt[0]);
        const attendeesTotal = parseInt(attendeesTxt[1]);

        attendees.innerText = `${attendeesCount + (signup ? 1 : -1)}/${attendeesTotal}`;
        signup ? card.classList.add('booked') : card.classList.remove('booked');
    }

    async signupToEvent(eventId, button) {
        button.disabled = true;
        button.textContent = 'Chargement...';

        try {
            const response = await jQuery.ajax({
                url: ajax_object.ajax_url,
                method: 'POST',
                data: {
                    action: 'event_signup',
                    event_id: eventId
                }
            });

            if (response.data && response.data.reload === true) {
                showToast(jQuery(response.data.html).text().trim(), 'error');
                setTimeout(reload, 2000);
            } else if (response.success === false) {
                button.textContent = 'Erreur';

                showToast(response.data.message, 'error');

                setTimeout(() => {
                    button.disabled = false;
                    button.textContent = 'Réserver';
                }, 2000); // Reset the button after 2 seconds
            } else if (response.data.data.state === 'booked') {
                button.textContent = 'Réservé';
                button.disabled = true;

                setTimeout(() => {
                    button.disabled = false;
                    button.textContent = 'Se désinscrire';
                    button.dataset.action = 'unsubscribe';

                    this.updateCard(eventId);
                }, 2000); // Reset the button after 2 seconds

            } else if (response.data.data.state === 'queued') {
                button.textContent = 'M\'enlever de la liste d’attente';
                button.disabled = false;
                button.dataset.action = 'unqueued';
                document.querySelector(`[data-event-id="${eventId}"]`).classList.add('queued');
                // window.location.reload()
            }
        } catch (error) {
            console.error('AJAX error:', error);
            button.textContent = 'Erreur';

            showToast("Une erreur s'est produite, merci de réessayer plus tard.", 'error');

            setTimeout(() => {
                button.disabled = false;
                button.textContent = 'Réserver';
            }, 2000); // Reset the button after 2 seconds
        }
    }

    async cancelSignupToEvent(eventId, button) {
        button.disabled = true;
        button.textContent = 'Chargement...';

        try {
            const response = await jQuery.ajax({
                url: ajax_object.ajax_url,
                method: 'POST',
                data: {
                    action: 'event_cancel_signup',
                    event_id: eventId
                }
            });

            if (response.data && response.data.reload === true) {
                showToast(jQuery(response.data.html).text().trim(), 'error');
                setTimeout(reload, 2000);
                return;
            }

            switch (true) {
                case response.data.data['hydra:description'] === 'api.error.attendee.already-attending':
                    button.disabled = true;
                    button.textContent = 'Vous participez déjà à ce cours';
                    break;
                case response.data.data['hydra:description'] === 'api.error.attendee.event-in-the-past':
                    button.disabled = true;
                    button.textContent = 'Ce cours a déjà eu lieu';
                    break;
                case response.data.data['hydra:description'] === 'api.error.attendee.anticipation':
                    button.disabled = true;
                    button.textContent = 'Le délai d’anticipation n’est pas respecté.';
                    break;
            }

            // console.log('Cancel signup response:', response);

            if (response.success === true) {
                button.textContent = 'Se désinscrire';
                button.disabled = true;

                setTimeout(() => {
                    button.disabled = false;
                    button.textContent = 'Réserver';
                    button.dataset.action = 'signup';

                    this.updateCard(eventId, false);
                }, 2000); // Reset the button after 2 seconds

            } else {
                console.error('Error cancelling signup:', response.data);
                button.textContent = 'Erreur';

                setTimeout(() => {
                    button.disabled = false;
                    button.textContent = 'Se désinscrire';
                }, 2000); // Reset the button after 2 seconds
            }
        } catch (error) {
            console.error('AJAX error:', error);
            button.textContent = 'Erreur';

            setTimeout(() => {
                button.disabled = false;
                button.textContent = 'Se désinscrire';
            }, 2000); // Reset the button after 2 seconds
        }
    }

    async unqueuedEvent(eventId, button) {
        button.disabled = true;
        button.textContent = 'Chargement...';

        try {
            const response = await jQuery.ajax({
                url: ajax_object.ajax_url,
                method: 'POST',
                data: {
                    action: 'event_cancel_signup',
                    event_id: eventId
                }
            });

            if (response.data && response.data.reload === true) {
                showToast(jQuery(response.data.html).text().trim(), 'error');
                setTimeout(reload, 2000);
                return;
            }

            switch (true) {
                case response.data.data['hydra:description'] === 'api.error.attendee.already-attending':
                    button.disabled = true;
                    button.textContent = 'Vous participez déjà à ce cours';
                    break;
                case response.data.data['hydra:description'] === 'api.error.attendee.event-in-the-past':
                    button.disabled = true;
                    button.textContent = 'Ce cours a déjà eu lieu';
                    break;
                case response.data.data['hydra:description'] === 'api.error.attendee.anticipation':
                    button.disabled = true;
                    button.textContent = 'Le délai d’anticipation n’est pas respecté.';
                    break;
            }

            // console.log('Cancel signup response:', response);

            if (response.success === true) {
                // button.textContent = 'Se désinscrire';
                button.disabled = true;

                setTimeout(() => {
                    button.disabled = false;
                    button.textContent = 'Rejoindre la liste d\'attente';
                    button.dataset.action = 'signup';
                    document.querySelector(`[data-event-id="${eventId}"]`).classList.remove('queued');
                    // window.location.reload();
                }, 2000); // Reset the button after 2 seconds

            } else {
                console.error('Error cancelling signup:', response.data);
                button.textContent = 'Erreur';

                setTimeout(() => {
                    button.disabled = false;
                    button.textContent = 'Se désinscrire';
                }, 2000); // Reset the button after 2 seconds
            }
        } catch (error) {
            console.error('AJAX error:', error);
            button.textContent = 'Erreur';

            setTimeout(() => {
                button.disabled = false;
                button.textContent = 'Se désinscrire';
            }, 2000); // Reset the button after 2 seconds
        }
    }

    closeReservationPopup() {
        const overlay = this.container.querySelector('.planning-overlay');
        const popup = this.container.querySelector('.booking-event-popup');

        overlay.style.display = 'none';
        popup.style.display = 'none';
    }

    async changeWeek(direction) {
        try {
            this.container.style.opacity = '0.5';
            const response = await jQuery.ajax({
                url: ajax_object.ajax_url,
                method: 'POST',
                data: {
                    action: 'update_planning',
                    direction: direction,
                    studio_id: this.container.dataset.studioId,
                    current_date: this.container.dataset.currentDate || null
                }
            });

            if (response.success) {
                this.container.innerHTML = response.data.html;
                this.container.dataset.currentDate = response.data.currentDate;
                this.init();

                handleReloadedContent(document.querySelector('[data-tab-content].active'), false);
            }
        } catch (error) {
            console.error('Error updating planning:', error);
        } finally {
            this.container.style.opacity = '1';
        }
    }

    getCurrentDates() {
        const dates = [];
        const currentDate = new Date(this.container.dataset.currentDate);

        const dayOfWeek = currentDate.getDay(); // 0 (sunday) to 6 (saturday)
        const monday = new Date(currentDate);
        monday.setDate(currentDate.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1)); // find monday

        for (let i = 0; i < 7; i++) {
            const nextDate = new Date(monday);
            nextDate.setDate(monday.getDate() + i);
            dates.push(nextDate.toISOString().split('T')[0]);
        }

        return dates;
    }

    getMonthFromDate() {
        return parseInt(this.container.dataset.currentDate.split('-')[1], 10) - 1; // Months are 0-based in JavaScript
    }

    getYearFromDate() {
        return parseInt(this.container.dataset.currentDate.split('-')[0], 10);
    }

    toggleWeekPicker() {
        const weekPickerContainer = document.querySelector('.week-picker-container');
        weekPickerContainer.classList.toggle('active');
    }

    initWeekPicker() {
        const weekPickerContainer = document.querySelector('.week-picker-container');

        if (!weekPickerContainer) {
            jQuery(`
                <div class="week-picker-container">
                    <div id="week-picker"></div>
                </div>
            `).appendTo('body');
        }

        const currentDates = this.getCurrentDates();
        const currentMonth = this.getMonthFromDate();
        const currentYear = this.getYearFromDate();

        const planning = this;

        if (!this.calendar) {
            this.calendar = new Calendar('#week-picker', {
                enableWeekNumbers: true,
                selectionDatesMode: 'multiple-ranged',
                selectedDates: currentDates,
                onClickWeekNumber(self, number, year, dateEls) {
                    const selectedDates = dateEls.map((dateEl) => dateEl.dataset.vcDate);
                    planning.toggleWeekPicker()
                    planning.changeWeek(selectedDates[0]);
                },
                locale: 'fr-FR',
            });
            this.calendar.init();
        } else {
            this.calendar.set({
                selectedMonth: currentMonth,
                selectedYear: currentYear,
                selectedDates: currentDates,
            })
        }
    }

    selectActivityType(activityId) {
        const activityFilters = document.querySelectorAll('.activity-selector');

        activityFilters.forEach(activityFilter => {
            if (activityFilter.getAttribute('data-activity-id') === activityId || activityId === 'all') {
                activityFilter.classList.add('active');
            } else {
                activityFilter.classList.remove('active');
            }
        });

        let events = this.container.querySelectorAll('.event');
        events.forEach(event => {
            if (event.getAttribute('data-activity-id') === activityId || activityId === 'all') {
                event.style.display = 'flex';
            } else {
                event.style.display = 'none';
            }
        });
    }

    selectCoach(coachIdsStr) {
        const coachFilters = document.querySelectorAll('.coach-selector-item');

        coachFilters.forEach(coachFilter => {
            if (coachFilter.getAttribute('data-coach-id') === coachIdsStr || coachIdsStr === 'all') {
                coachFilter.classList.add('active');
            } else {
                coachFilter.classList.remove('active');
            }
        });

        let events = this.container.querySelectorAll('.event');
        events.forEach(event => {
            const coachIds = coachIdsStr.split(',');
            if (coachIds.includes(event.getAttribute('data-coach-id')) || coachIdsStr === 'all') {
                event.style.display = 'flex';
            } else {
                event.style.display = 'none';
            }
        });
    }
}

new Planning()